export default __webpack_public_path__ + "static/media/logo-arvore.1bc637bf.png";